export default __webpack_public_path__ + "static/media/vitalsDashboard.336d8a87.svg";